<template>
    <div class="input-container">
        <label for="inputDescription" class="form-label custom-label m-0">{{lable}}<span class="text-danger">*</span></label>
        <textarea class="custom-input form-control" id="inputDescription" rows="4" cols="6"
                  placeholder=""
                  @input="inputHandler"
                  v-model="description.description"/>
        <div class="err" v-if="errors.length > 0 || err.length > 0">
            <div v-for="msg in errors" class="text-danger">{{msg}}</div>
            <div v-if="!changeFlag" v-for="msg2 in err" class="text-danger">{{msg2}}</div>
        </div>
    </div>
</template>


<script>

    import {ref, toRef} from "vue";
    import {useStore} from "vuex";

    export default {
        name: 'app',
        props: {
            description: Object,
            lable: String,
            err: Object,
            inputHandler: Function,
            type: String
        },

        setup(props) {
            const store = useStore();
            const description = toRef(props, 'description');
            const lable = toRef(props, 'lable');
            const type = toRef(props, 'type');
            const inputHandlerCB = toRef(props, 'inputHandler');
            const err = toRef(props, 'err');
            const changeFlag = ref(false);
            const errors = ref([]);


            const inputHandler = async (e) => {
                changeFlag.value = true;
                let enteredValue = e.target.value;

                description.value.description = enteredValue.length === 1 ? enteredValue.trim() : enteredValue;

                if (enteredValue.length < 1)
                    errors.value = ['*Required'];
                else if (enteredValue.length > 4294967295) // larger than longtext size
                    errors.value = ['* Too Long'];
                else
                    errors.value = [];

                if (description.value.name.length > 0 || description.value.description.length) {
                    await store.dispatch('setDataFlag', true);
                } else {
                    await store.dispatch('setDataFlag', false);
                }
                if (type.value !== 'template-description')
                    inputHandlerCB.value();
            };

            return {
                description,
                lable,
                err,
                errors,
                changeFlag,
                inputHandlerCB,
                type,
                inputHandler
            }
        }
    }
</script>

<style scoped>

    .input-container {
        height: 133px;
        margin-bottom: 12px;
    }

    .custom-label {
        font-size: 15px;
        font-weight: 500;
    }

    .custom-input {
        font-size: 14px;
        font-weight: 500;
        color: var(--main-color);
    }

    .custom-input,
    .custom-input:focus,
    .custom-input:active {
        background-color: transparent;
        border: 1px solid #39525C;
        outline: 0;
        box-shadow: 0 0 0 0;
        color: var(--main-color);
    }

    textarea {
        height: 110px;
        min-height: 110px;
        max-height: 110px;
    }


</style>